import { useCallback, useState } from "react";

import { isError } from "../services/ChannelApi";
import { userApi } from "../services/UserApi";
import { useTeamsContext } from "../state/TeamsContextProvider";
import { isMobileClient } from "../utils/clientHelper";
import { clientEventTracker } from "../utils/clientTelemetry";
import { startNpsSurveyTask } from "../utils/startTaskWrapper";
import { useUserInfo } from "./useUserInfo";

export const useNps = (pageName: "chat" | "team" | "personal" | "meeting") => {
  const { teamsContext } = useTeamsContext();
  const { user, npsEligibility, setNpsEligibility } = useUserInfo();
  const [npsVisible, setNpsVisible] = useState<boolean>(false);

  const loadNpsSurveyIfEligible = useCallback(async () => {
    if (npsVisible || !npsEligibility || isMobileClient(teamsContext)) return;

    startNpsSurveyTask(npsSurveyDismissed);
    setNpsVisible(true);
    clientEventTracker.track("NPS sent", user, {
      source: "Teams",
      page: pageName,
    });

    async function npsSurveyDismissed() {
      setNpsVisible(false);
      setNpsEligibility(false);

      const response = await userApi.updateUserDismissedAtForNps(teamsContext);
      if (isError(response)) {
        clientEventTracker.trackFatalError("nps/dismiss-error", user, {
          error: response,
          pageName,
        });
        console.error(response);
        return;
      }

      if (response.shouldLogEvent) {
        clientEventTracker.track("NPS dismissed", user, {
          source: "Teams",
          page: pageName,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [npsEligibility, pageName, teamsContext, user]);

  return { loadNpsSurveyIfEligible };
};
